/* EL CAJÓN DE LA BOLSA · 27-ago-2026
 * El porqué de la función está en `snippets/avora-cajon.liquid`.
 *
 * 🔴 EL PRECIO VIENE EN CENTAVOS. `/cart.js` devuelve `line_price: 39000` para
 * $390. Escribirlo tal cual pondría "$39,000" en la bolsa — el error más caro
 * posible en esta pantalla. (En `/search/suggest.json` es al revés: ahí llega en
 * pesos. Dos endpoints de la misma tienda con dos unidades distintas.)
 *
 * 🔴 SE PIDE AL ABRIR, SIEMPRE. Nada de guardar la bolsa en una variable: se
 * puede haber agregado algo desde otra pestaña, o desde la ficha sin pasar por
 * aquí. Una bolsa que enseña lo de hace tres páginas es peor que ninguna.
 */
(function () {
  if (typeof fetch !== 'function') return;   /* sin fetch, el enlace a /cart hace su trabajo */

  var panel = document.querySelector('[data-cajon]');
  if (!panel) return;

  var lista   = panel.querySelector('[data-cajon-lista]');
  var aviso   = panel.querySelector('[data-cajon-aviso]');
  var vacio   = panel.querySelector('[data-cajon-vacio]');
  var pie     = panel.querySelector('[data-cajon-pie]');
  var totalEl = panel.querySelector('[data-cajon-total]');

  /* Mismo motivo que en el buscador y en los guardados: `.a-cima` se TRANSFORMA
     al bajar, y un ancestro transformado se vuelve el marco de referencia de
     cualquier `position: fixed` — el cajón saldría recortado a la altura de la
     cabecera. Ver `assets/avora-buscador.js`. */
  if (panel.parentNode !== document.body) document.body.appendChild(panel);

  var devolver = null;
  var altura = 0;
  var reanimar = false;   /* lo enciende `abre()`; lo consume `pinta()` */

  function traba() {
    altura = window.scrollY || document.documentElement.scrollTop || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = -altura + 'px';
    document.body.style.width = '100%';
  }
  function destraba() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, altura);
  }

  /* ── DINERO ─────────────────────────────────────────────────────────────
     🔴 SE FORMATEA CON EL `money_format` DE LA TIENDA, NO CON `Intl`. Aquí
     decía que `Intl` "pone los decimales que la tienda usa" y no es cierto:
     `Intl.NumberFormat('es-MX')` devuelve "$1,998.00" y esta tienda escribe
     "$ 1,998.00", con espacio (medido el 28-ago). El precio que pinta el
     servidor y el que repinta el cajón al tocar «+» quedaban distintos en la
     misma columna. El formato viaja en el DOM desde Liquid. */
  function formato() {
    var n = document.querySelector('[data-money]');
    return (n && n.getAttribute('data-money')) || '$ {{amount}}';
  }

  function miles(n, milesSep, decSep, decimales) {
    var partes = n.toFixed(decimales).split('.');
    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, milesSep);
    return decimales ? partes.join(decSep) : partes[0];
  }

  function pesos(centavos) {
    var v = (centavos || 0) / 100;
    return formato()
      .replace('{{amount_no_decimals_with_comma_separator}}', miles(v, '.', ',', 0))
      .replace('{{amount_with_comma_separator}}',             miles(v, '.', ',', 2))
      .replace('{{amount_no_decimals}}',                      miles(v, ',', '.', 0))
      .replace('{{amount}}',                                  miles(v, ',', '.', 2));
  }

  function esc(t) {
    return String(t == null ? '' : t)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ── PINTAR ─────────────────────────────────────────────────────────────── */
  function pinta(carrito) {
    var items = carrito.items || [];

    /* 🔴 AVISO DISTINTO AL DE ENTRADA, A PROPÓSITO. Aquí NO se puede emitir
       `avora:bolsa`: este mismo archivo lo escucha para releer `/cart.js`, y
       emitirlo desde el pintado sería un bucle. `avora:bolsa-pintada` sale
       DESPUÉS de que la bolsa ya cambió y sólo lo escucha quien necesita
       enterarse — hoy, el puente de WhatsApp, que tiene que rearmar su mensaje
       cuando la clienta sube o baja una cantidad sin recargar la página. */
    document.dispatchEvent(new CustomEvent('avora:bolsa-pintada', { detail: carrito }));

    if (!items.length) {
      lista.innerHTML = '';
      vacio.hidden = false;
      pie.hidden = true;
      /* 🔴 LA FOTO NACE `lazy` Y AQUÍ SE FUERZA. Es el precio de que viaje en la
         cabecera de TODAS las páginas: `lazy` evita bajarla a quien nunca abre
         una bolsa vacía. Pero `lazy` se resuelve con la misma maquinaria de
         intersección que el navegador silencia mientras el panel está `hidden` —
         medido el 27-ago: 200 en la red, `naturalWidth` en 0 después de tres
         segundos con el cajón ya abierto. O sea: hueco beige justo en la pantalla
         que se acaba de abrir. Pedirla a mano en el momento en que de verdad se
         va a ver arregla las dos cosas. */
      var rieles = vacio.querySelector('.s-cajon__rieles');
      if (rieles && rieles.loading === 'lazy') rieles.loading = 'eager';
      return;
    }
    vacio.hidden = true;
    pie.hidden = false;
    ponTotal(carrito.total_price);

    /* 🔴 LA LISTA SE RECONCILIA, YA NO SE REHACE. Antes esto era
       `lista.innerHTML = items.map(...)`: cada cambio de cantidad destruía las
       seis líneas y creaba seis nuevas. Rápido de escribir y con dos costos que
       se ven: la línea que se quita no puede despedirse —el elemento ya no
       existe— y las de abajo no pueden subir a su nuevo sitio, porque tampoco
       son las mismas. Todo parpadea y se reacomoda de un tirón.
       Ahora se busca cada línea por su CLAVE: si ya está, se le actualizan los
       números; si no, se crea; y la que desapareció del carrito se marca para
       que el motor de reacomodo la despida. Ver `avora-flip.js`. */
    function cambia() {
      var vivas = {};
      [].slice.call(lista.children).forEach(function (li) {
        vivas[li.getAttribute('data-clave')] = li;
      });

      var orden = items.map(function (it, i) {
        var li = vivas[it.key];
        if (li) { actualiza(li, it); delete vivas[it.key]; }
        else { li = creaLinea(it); }
        return li;
      });

      /* Las que ya no vienen en el carrito. No se borran aquí: se esconden, y
         el motor las devuelve un momento a pantalla para apagarlas. Se rematan
         de verdad más abajo, cuando ya terminaron de irse. */
      Object.keys(vivas).forEach(function (k) { vivas[k].hidden = true; });

      /* `appendChild` sobre un nodo que ya está dentro lo MUEVE, no lo duplica:
         recorrer en orden deja la lista en el orden del carrito y empuja al
         final las que se están yendo (que no ocupan espacio: van ocultas). */
      orden.forEach(function (li, i) {
        li.style.setProperty('--i', i);
        li.setAttribute('data-i', i);
        lista.appendChild(li);
      });
    }

    /* Con el cajón cerrado no hay nada que animar y las medidas darían cero
       —`trae()` también corre al agregar desde la ficha, con el panel oculto—.
       Ahí se cambia y ya. */
    if (!panel.hidden && window.AvoraFlip) {
      /* 🔴 HAY QUE APAGAR LA ANIMACIÓN DE ENTRADA ANTES DE REACOMODAR, o el
         reacomodo no se ve. Las líneas entran con
         `animation: cajon-linea … both`, y `both` deja fijado el fotograma
         final —`translate: 0 0`— para siempre. Una animación en curso o
         rellenada gana en la cascada incluso contra un estilo EN LÍNEA: el
         motor escribía su `translate` y el navegador lo ignoraba, así que las
         líneas de abajo saltaban a su sitio en vez de subir.
         Apagarla aquí no pierde nada: esa animación ya terminó y solo estaba
         sosteniendo el mismo valor de reposo. Al volver a abrir el cajón,
         `reanimar` la devuelve. */
      [].slice.call(lista.children).forEach(function (li) { li.style.animation = 'none'; });
      AvoraFlip.reacomoda(lista, [].slice.call(lista.children), cambia);
    } else {
      cambia();
    }

    /* 🔴 AL ABRIR, EL ESCALONADO SE VUELVE A CORRER A MANO. Es la contra de
       reconciliar: como las líneas ya no se recrean en cada pintada, tampoco
       vuelven a disparar su animación de entrada, y a partir de la segunda vez
       que abres el cajón la lista aparecía de golpe. Reiniciar la animación es
       más honesto que vaciar la lista al abrir: vaciarla dejaría el panel en
       blanco hasta que conteste `/cart.js`. */
    if (reanimar) {
      reanimar = false;
      [].slice.call(lista.children).forEach(function (li) {
        li.style.animation = 'none';
        void li.offsetWidth;
        li.style.animation = '';
      });
    }

    /* Rematar de verdad las que se fueron, después de que se despidieron. */
    setTimeout(function () {
      [].slice.call(lista.children).forEach(function (li) {
        if (li.hidden) lista.removeChild(li);
      });
    }, 600);
  }

  /* Los números de una línea que ya existe. Se tocan solo si cambiaron: escribir
     el mismo texto reinicia animaciones y hace parpadear al lector de pantalla. */
  function actualiza(li, it) {
    var n = li.querySelector('[data-n]');
    if (n && n.textContent !== String(it.quantity)) n.textContent = it.quantity;
    var meta = li.querySelector('.s-cajon__meta');
    var txt = textoMeta(it);
    if (meta && meta.textContent !== txt) meta.textContent = txt;
  }

  function textoMeta(it) {
    var opciones = (it.options_with_values || [])
      .filter(function (o) { return o.value && o.value !== 'Default Title'; })
      .map(function (o) { return o.value; })
      .join(' · ');
    return (opciones ? opciones + ' · ' : '') + pesos(it.final_line_price);
  }

  /* 🔴 EL ENVOLTORIO ES UN `<ul>`, NO UN `<div>`. Un `<li>` suelto dentro de un
     `div` deja al analizador de HTML decidiendo qué hacer con un elemento que
     no puede estar ahí. Con su padre legítimo el fragmento sale exacto.
     Y `firstElementChild`, no `firstChild`: cualquier espacio delante
     devolvería un nodo de texto. */
  function creaLinea(it) {
    var envoltorio = document.createElement('ul');
    envoltorio.innerHTML = plantillaLinea(it);
    return envoltorio.firstElementChild;
  }

  function plantillaLinea(it) {
    return [it].map(function (it, i) {
      /* La variante se enseña SIEMPRE: vende ropa con talla y color, y una línea
         que solo dice el nombre obliga a abrir la ficha para saber qué talla se
         está por comprar. Shopify llama "Default Title" a la variante de un
         producto sin opciones — eso no se imprime. */
      var opciones = (it.options_with_values || [])
        .filter(function (o) { return o.value && o.value !== 'Default Title'; })
        .map(function (o) { return esc(o.value); })
        .join(' · ');

      var foto = it.image
        ? '<img src="' + esc(it.image).replace(/(\.\w+)(\?|$)/, '_160x$1$2') +
          '" alt="" width="64" height="80" loading="lazy" decoding="async">'
        : '<span class="s-cajon__sinfoto"></span>';

      return '' +
        /* `--i` alimenta el escalonado de entrada (ver `avora-cajon.css`).
           `data-i` se queda: es por donde se depura sin abrir el inspector. */
        '<li class="s-cajon__linea" data-clave="' + esc(it.key) + '" data-i="' + i +
          '" style="--i:' + i + '">' +
          '<a class="s-cajon__foto" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + foto + '</a>' +
          '<div class="s-cajon__d">' +
            '<a class="s-cajon__nombre" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
            '<p class="s-cajon__meta">' +
              (opciones ? opciones + ' · ' : '') + pesos(it.final_line_price) +
            '</p>' +
          '</div>' +
          '<div class="s-cajon__cant">' +
            '<button type="button" data-menos aria-label="Quitar uno de ' + esc(it.product_title) + '">&minus;</button>' +
            '<span data-n>' + it.quantity + '</span>' +
            '<button type="button" data-mas aria-label="Agregar uno de ' + esc(it.product_title) + '">+</button>' +
          '</div>' +
        '</li>';
    }).join('');
  }

  /* ── EL TOTAL ───────────────────────────────────────────────────────────
     🔴 SOLO SE ANIMA SI DE VERDAD CAMBIÓ. `pinta()` corre también al abrir el
     cajón y en cada relectura de `/cart.js`: animar siempre haría parpadear el
     total cada vez que se mira la bolsa, que es exactamente el ruido que esta
     pantalla no necesita. La cifra ya va en `tabular-nums`, así que no baila de
     ancho al cambiar de dígitos. */
  function ponTotal(centavos) {
    var txt = pesos(centavos);
    if (totalEl.textContent === txt) return;
    totalEl.textContent = txt;
    totalEl.removeAttribute('data-cambia');
    void totalEl.offsetWidth;        /* reinicia la animación si venía corriendo */
    totalEl.setAttribute('data-cambia', '');
  }

  /* ── EL NÚMERO DE LA CABECERA ───────────────────────────────────────────
     Se pone al día desde aquí porque el cajón es lo único que cambia la bolsa
     sin recargar. Si no, la pastilla se queda en el número con el que cargó la
     página y la clienta ve dos verdades a la vez. */
  var ultimaCuenta = null;

  function cuenta(carrito) {
    var n = carrito.item_count || 0;

    /* 🔴 EL PULSO SOLO CUANDO SUBE, Y NUNCA EN LA PRIMERA LECTURA. Es el único
       aviso de que algo entró a la bolsa cuando la clienta agrega desde la
       ficha y el cajón no se abre. Si pulsara también al bajar sería un premio
       por quitar algo; y si pulsara en la primera lectura, la pastilla
       parpadearía sola en cada carga de página sin que nadie tocara nada. */
    var sube = ultimaCuenta !== null && n > ultimaCuenta;
    ultimaCuenta = n;

    [].slice.call(document.querySelectorAll('.a-cuenta-bolsa')).forEach(function (c) {
      c.textContent = n;
      if (n) c.removeAttribute('data-vacia'); else c.setAttribute('data-vacia', '');
      if (sube) {
        c.removeAttribute('data-sube');
        void c.offsetWidth;          /* sin esto, dos "agregar" seguidos solo pulsan una vez */
        c.setAttribute('data-sube', '');
      }
    });
    [].slice.call(document.querySelectorAll('.a-header__bolsa')).forEach(function (a) {
      a.setAttribute('aria-label', 'Bolsa, ' + n + (n === 1 ? ' prenda' : ' prendas'));
    });
  }

  function trae() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { pinta(c); cuenta(c); return c; });
  }

  /* ── CAMBIAR CANTIDAD ───────────────────────────────────────────────────
     `/cart/change.js` se pide por CLAVE de línea, no por índice: dos líneas del
     mismo producto en distinta talla comparten id de producto, y con el índice
     una petición lenta puede acabar cambiando la línea equivocada si la lista se
     repintó en medio. */
  var relojAviso = null;
  function escondeAviso() {
    if (relojAviso) { clearTimeout(relojAviso); relojAviso = null; }
    aviso.hidden = true;
    aviso.textContent = '';
  }
  function muestraAviso(texto) {
    if (!texto) return;
    aviso.textContent = texto;
    aviso.hidden = false;
    /* Se va solo: es la respuesta a un toque, no un estado de la bolsa. Ocho
       segundos alcanzan para leerlo sin que se quede ahí de adorno. */
    relojAviso = setTimeout(escondeAviso, 8000);
  }

  var ocupado = false;
  function cambia(clave, cantidad, li) {
    if (ocupado) return;
    ocupado = true;
    if (li) li.setAttribute('data-ocupada', '');
    escondeAviso();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: clave, quantity: cantidad })
    })
      .then(function (r) {
        return r.json().then(function (cuerpo) { return { ok: r.ok, cuerpo: cuerpo }; });
      })
      .then(function (res) {
        if (res.ok) { pinta(res.cuerpo); cuenta(res.cuerpo); return; }

        /* 🔴 UN 422 NO ES UN FALLO: ES LA TIENDA CONTESTANDO. Casi todo este
           catálogo es pieza única, así que subir de 1 devuelve
           "Debido a la disponibilidad, solo se añadió un artículo al carrito".
           La primera versión recargaba la página ahí: la clienta tocaba "+", se
           le recargaba todo y nada le decía por qué. Ahora se enseña el motivo
           —con las palabras de Shopify, que son las que conocen el inventario— y
           se vuelve a pedir la bolsa para que el número de la pantalla sea el
           real, no el que se intentó. */
        muestraAviso(res.cuerpo && (res.cuerpo.description || res.cuerpo.message));
        return trae();
      })
      /* Aquí sí: si ni siquiera se pudo hablar con la tienda, dejar la pantalla
         con un número y la bolsa real con otro es la peor de las dos salidas. */
      .catch(function () { window.location.reload(); })
      .then(function () {
        ocupado = false;
        if (li) li.removeAttribute('data-ocupada');
      });
  }

  lista.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-menos],[data-mas]');
    if (!b) return;
    var li = b.closest('.s-cajon__linea');
    if (!li) return;
    var n = parseInt(li.querySelector('[data-n]').textContent, 10) || 0;
    /* Bajar de 1 quita la línea: `quantity: 0` es como Shopify borra. No hace
       falta un botón "Quitar" aparte — el menos ya lo dice. */
    cambia(li.getAttribute('data-clave'), b.hasAttribute('data-mas') ? n + 1 : n - 1, li);
  });

  /* ── ABRIR / CERRAR ─────────────────────────────────────────────────────── */
  function abre(e) {
    if (e) e.preventDefault();
    devolver = document.activeElement;
    reanimar = true;
    AvoraPanel.abre(panel);
    traba();
    trae();
    /* Un cuadro de animación no alcanza: el elemento acaba de dejar de estar
       `hidden` y de que le fijen el cuerpo encima. Ver `avora-buscador.js`. */
    setTimeout(function () {
      var c = panel.querySelector('[data-cajon-cerrar]');
      if (c) { try { c.focus({ preventScroll: true }); } catch (err) { c.focus(); } }
    }, 60);
  }
  /* El foco vuelve YA, sin esperar a la animación: quien navega con teclado no
     tiene por qué pagar 240ms para recuperar el cursor. Destrabar el fondo sí
     espera, porque devuelve el scroll y hacerlo mientras el telón todavía se
     apaga se ve como un brinco detrás del panel. */
  function cierra() {
    AvoraPanel.cierra(panel, destraba);
    if (devolver && devolver.focus) devolver.focus();
  }

  /* El gesto de apartar la bolsa con el pulgar. Ver `avora-panel.js`. */
  if (AvoraPanel.arrastrable) AvoraPanel.arrastrable(panel, cierra);

  [].slice.call(document.querySelectorAll('[data-abre-cajon]'))
    .forEach(function (a) { a.addEventListener('click', abre); });
  [].slice.call(panel.querySelectorAll('[data-cajon-cerrar]'))
    .forEach(function (b) { b.addEventListener('click', cierra); });

  /* El telón cierra: tocar fuera es el gesto que todo el mundo intenta antes de
     buscar la equis. */
  panel.addEventListener('click', function (e) { if (e.target === panel) cierra(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) cierra();
  });

  /* 🔴 ESTE ARCHIVO ES EL ÚNICO QUE ESCRIBE LA CUENTA DE LA CABECERA. La ficha
     agregaba a la bolsa y actualizaba el número por su cuenta, buscando enlaces
     cuyo texto fuera "Bolsa (0)" — un formato que se retiró de la pantalla el
     26-ago, así que llevaba semanas sin acertar y en silencio. Ahora la ficha
     solo AVISA (`avora:bolsa`) y aquí se relee `/cart.js`.

     El aviso de "ya está en su bolsa" de la ficha se queda: es la confirmación
     en el sitio donde se decidió, y abrir el cajón encima sería taparlo. */
  document.addEventListener('avora:bolsa', function () { trae(); });
})();

